import { Scroller } from 'src/components/Scroller/Scroller'
import { TestimonialItem } from 'src/components/TestimonialItem/TestimonialItem'
import { FormattedText } from 'src/core/ds/FormattedText'
import styles from '../index.module.scss'

export function CustomTestimonials({ testimonials }) {
  return (
    <div className={styles.testimonial}>
      <h2>
        <FormattedText id="landing.testimonials.title" />
      </h2>
      <p>
        <FormattedText id="landing.testimonials.description" />
      </p>
      <Scroller direction="right" speed="slow">
        {testimonials.map((item) => (
          <TestimonialItem key={item.id} data={item} />
        ))}
      </Scroller>
    </div>
  )
}
